import numeral from "numeral"

export const MONTHS = [
  { value: '1', label: 'January' },
  { value: '2', label: 'February' },
  { value: '3', label: 'March' },
  { value: '4', label: 'April' },
  { value: '5', label: 'May' },
  { value: '6', label: 'June' },
  { value: '7', label: 'July' },
  { value: '8', label: 'August' },
  { value: '9', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' }
]

export const getSessionInfo = () => {
  let sessionInfoJson = { userAgent: null, ipAddress: null }
  try {
    let sessionInfo = window.localStorage.getItem('sessionInfo')
    if (sessionInfo) {
      sessionInfoJson = JSON.parse(sessionInfo)
    }
  } catch(e) {
    console.error(e)
  }

  if (!sessionInfoJson.userAgent && window?.navigator?.userAgent) {
    sessionInfoJson.userAgent = window.navigator.userAgent
  }
  return sessionInfoJson
}

export const ucwords = (str) => {
  return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, s => s.toUpperCase())
}

/* eslint-disable */
export const validPhoneNumber = (str) => {
  return str.match(/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/)
}
/* eslint-enable */

/* eslint-disable */
export const validEmail = (str) => {
  return str.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
}
/* eslint-enable */

export const isNumber = n => { return !isNaN(parseFloat(n)) && !isNaN(n - 0) }

export const isUploadSupported = () => {
  if (navigator.userAgent.match(/(Android (1.0|1.1|1.5|1.6|2.0|2.1))|(Windows Phone (OS 7|8.0))|(XBLWP)|(ZuneWP)|(w(eb)?OSBrowser)|(webOS)|(Kindle\/(1.0|2.0|2.5|3.0))/)) {
      return false;
  }
  var elem = document.createElement('input');
  elem.type = 'file';
  return !elem.disabled;
};

export const getUrlVars = () => {
  var vars = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => vars[key] = value)
  return vars
}

export const buildQueryStringFromJSON = (params) => {
  var str = Object.keys(params).map(key => key + '=' + params[key]).join('&')
  return (str) ? '?' + str : ''
}

export const discectError = (e, defaultMessage = null) => {
  if (e.message.substr(0,1) === '{') {
    const errorJson = JSON.parse(e.message)
    return errorJson?.error?.message || defaultMessage || 'General Error'
  } else if (e?.response?.data) {
    return e.response.data?.message || defaultMessage || 'General Error'
  }
  return e.message
}

export const isValid = (data, arr) => {
  let invalid = []
  arr.forEach(key => {
    if (!data[key] || data[key] === '') invalid.push(key)
  })
  // if (invalid.length) throw new Error(`Invalid entries ${invalid.join(', ')}`)
  return (invalid.length === 0)
}

export const formatPhoneNumber = phoneNumberString => {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }
  return null
}

export const formatMoney = (val, endingZeros = false) => {
  let amt = numeral(val).format('0,0.00')
  // if ((val / 100) < 100) {
  //   return amt
  // }
  if (endingZeros) return '$' + amt
  return '$' + amt.replace('.00', '')
}

export const getTypeEnhanced = data => {
  let classes = 'tag--grey'
  let setStatus = (data.searchStatus) ? data.searchStatus : data.status
  let status = setStatus.replace(/_/g, ' ')
  if (['BAIL_POSTED'].indexOf(setStatus) >= 0) {
    classes = 'tag--blue'
  } else if (['ACCEPTED'].indexOf(setStatus) >= 0) {
    classes = 'tag--teal'
  } else if (['ERROR_PAYMENT','NEW','DOCUMENTS_NOT_SELECTED','INFORMATION_NOT_SELECTED','AWAITING_APPROVAL'].indexOf(setStatus) >= 0) {
    classes = 'tag--red'
  }
  if (setStatus === 'AWAITING_APPROVAL') status = 'READY FOR REVIEW'
  return <div className={`tag ${classes}`}>{status}</div>
}

export const fetchLocation = zipCode => {
  return new Promise((resolve, reject) => {
    const client = new XMLHttpRequest()
    client.open("GET", `${window.location.protocol}//api.zippopotam.us/us/${zipCode}`, true)
    client.onreadystatechange = () => {
      if(client.readyState === 4) {
        const json = JSON.parse(client.responseText)
        if (json.places && json.places.length > 0) {
          return resolve({ city: json.places[0]['place name'], state: json.places[0]['state'], zip: json['post code'] })
        }
        return reject({error: 'Place not found.'})
      }
    }
    client.send()
  })
}

export const transformPowerNumber = (suretyId, power) => {
  if (suretyId === '6a4a7aa2-6c32-4bb9-973f-db1bd0a62203') {
    const { prefix, number, suffix } = power
    if (prefix && number && suffix) {
      return `${suffix || ''}-${prefix || ''}-${number || ''}`.trim().toUpperCase()
    } else if (prefix && number) {
      return `2025-${prefix || ''}-${number || ''}`.trim().toUpperCase()
    }
  }
  return (power.po_number || power.powerNumber).trim().toUpperCase()
}

export const getSuretyLogo = (suretyId, suretyName) => {
  if (!suretyId) return null 
  return <img src={`/images/${suretyId}.png`} alt={suretyName || 'Surety Logo'} />
}